import { useSelect } from "@wordpress/data";
import { WEATHER_STORE } from "@/store/store";
import { WeatherSelect } from "@/store/type";
import { getCurrentDateWithDay } from "@/helpers/format-date";
import { WorldForecastItem } from "@/schemas/world-forecast-schema";

import CardList from "@/components/forecast/card-list/CardList";

import "./style.scss";

export const App = () => {
	const { forecastData, isLoading, error, selectedDate, locationSelected } =
		useSelect((select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
			const store = select(WEATHER_STORE);

			return {
				...store.getWorldForecastPrevisionState(),
				locationSelected: store.getWorldLocationState(),
				selectedDate: store.getWorldForecastPrevisionDateState(),
			};
		});

	const formattedData = Object.entries(
		forecastData.reduce<Record<string, WorldForecastItem[]>>((acc, item) => {
			const day = item.timestep.slice(0, 10);

			if (!acc[day]) {
				acc[day] = [];
			}

			acc[day].push(item);

			return acc;
		}, {}),
	)
		.map(([dateKey, items]) => {
			const { date, day } = getCurrentDateWithDay(new Date(dateKey));

			return {
				date: new Date(new Date(dateKey).setHours(14)),
				station_id: "hd",
				temperature_max: Math.max(...items.map((i) => i.temperature_2m)),
				temperature_min: Math.min(...items.map((i) => i.temperature_2m)),
				ww: Math.max(...items.map((i) => i.ww)),
				dayWeek: date,
				day,
			};
		})
		.slice(0, 3);

	if (isLoading && error) {
		return;
	}

	if (locationSelected.id === "") return;

	return (
		<div className="world-forecast-card-container">
			<CardList data={formattedData} selectedDate={selectedDate} type="world" />
		</div>
	);
};

export default App;
